export const SUPPORTED_CURRENCIES = ['EUR', 'USD', 'MRU', 'XOF', 'CHF'];

export const DEFAULT_CURRENCY = 'EUR';

export const CURRENCY_METADATA = {
  EUR: { symbol: '\u20AC', decimals: 2, name: 'Euro' },
  USD: { symbol: '$', decimals: 2, name: 'US Dollar' },
  MRU: { symbol: 'UM', decimals: 2, name: 'Ouguiya' },
  XOF: { symbol: 'CFA', decimals: 0, name: 'Franc CFA' },
  CHF: { symbol: 'CHF', decimals: 2, name: 'Schweizer Franken' },
};
